import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { clearGiftCardDetails, getGiftCardDetails } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { forwardRef } from 'react';
import { Button } from '../../subcomponents/button/button';
import { ButtonColor } from '../../subcomponents/button/types/color';
import { ButtonSize } from '../../subcomponents/button/types/size';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { GiftCardCheckerCardDetails } from './subcomponents/card-details';
import { GiftCardCheckerForm } from './subcomponents/form';
import { defaultGiftCardCheckerProps, giftCardCheckerPropsValidator } from './types/props';
const b = bemClassBuilder('v-gift-card-checker');
const GiftCardCheckerBase = (props, ref) => {
    const cardDetails = getGiftCardDetails();
    const { displayText } = props;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: !cardDetails ? (_jsx(GiftCardCheckerForm, Object.assign({}, props, { ref: ref }))) : (_jsxs(_Fragment, { children: [_jsx(GiftCardCheckerCardDetails, { displayText: displayText, cardDetails: cardDetails }), _jsx(Button, { color: ButtonColor.Primary, size: ButtonSize.Small, label: displayText.buttonBackLabel, onClick: () => clearGiftCardDetails() })] })) })));
};
export const GiftCardChecker = observer(forwardRef(GiftCardCheckerBase));
GiftCardChecker.displayName = 'GiftCardChecker';
/**
 * The **Gift Card Checker** component allows a user to enter a gift card number to retrieve details about the card.
 */
export const GiftCardCheckerComponent = withComponentWrapper(GiftCardChecker, defaultGiftCardCheckerProps, giftCardCheckerPropsValidator);
